<template>
  <div class="container-fluid">
    <div class="row flex-column flex-md-row">
      <nav class="col-12 col-md-2 bg-dark text-white d-flex flex-column align-items-start min-vh-100">
        <div class="mb-4 w-100 text-center mt-4">
          <img src="./assets/logo.webp" alt="Логотип" class="img-fluid" style="max-height: 50px;">
        </div>
        <Menu/>
      </nav>
      <div class="col-12 col-md-10 p-3 bg-very-light">
        <Head/>
        <main class="col-12 bg-light p-3 rounded-3">
          <router-view/>
        </main>
      </div>
    </div>
  </div>

</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.bg-secondary-muted {
  background-color: #dee2e6 !important;
}

.bg-soft {
  background-color: #e9ecef !important;
}

.bg-very-light {
  background-color: #f1f3f5 !important;
}
</style>
<script setup>
import Menu from './components/navigate/Menu.vue'
import Head from './components/navigate/Head.vue'
</script>